import React, { useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { AuthService, AuthServiceConfig, Router, VisAuthService } from '@vis-auth/vis-auth';
import { AuthServiceProvider } from '../utils/AuthServiceContext';
import { AuthStateProvider } from '../utils/AuthStateContext';
import RefreshSession from '../utils/RefreshSession';

type AuthServiceInit = (authConfig: AuthServiceConfig, router: Router) => AuthService;

export type SecurityProps = {
  authConfig: AuthServiceConfig;
  authServiceInit?: AuthServiceInit;
  children?: React.ReactNode;
};

const DefaultInit = (authConfig: AuthServiceConfig, router: Router): AuthService =>
  new VisAuthService(authConfig, router);

export function Security({ children, authConfig, authServiceInit = DefaultInit }: SecurityProps) {
  const history = useHistory();
  const auth = useMemo(() => authServiceInit(authConfig, history), [authConfig, history, authServiceInit]);
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth.handleAuthentication();
  }, [auth]);

  return (
    <AuthServiceProvider value={auth}>
      <AuthStateProvider>
        {authConfig.session?.disableNavigationRefresh ? null : <RefreshSession />}
        {children}
      </AuthStateProvider>
    </AuthServiceProvider>
  );
}
